import React, { FC } from "react";
import MessageForm, { MessageFormData } from "../MessageForm/MessageForm";

export interface OfflineFormProps {
    onSubmit(data: MessageFormData): void;
}

const OfflineForm: FC<OfflineFormProps> = (props) => {
    return <MessageForm
        title="Offline message card title"
        onSubmit={props.onSubmit}
    />;
};

export default OfflineForm;
